import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('quote_rates',
  '/plans/quote_rates',
  'quote_rates')
const reducer = generator.generate()

export default reducer

